import * as React from 'react';
import Select from './Select';
import '../css/barnardos.css';

const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
const monthName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export interface Props {
    id?: string;
    title: string;
    showMonthName?: boolean;
    value: {
        month: string;
        year: string;
    };

    displayOptions?: {
        divClassName?: string;
        labelClassName?: string;
        monthSelectClassName?: string;
        yearSelectClassName?: string;
        selectClassName?: string;
    };

    validation: {
        validator: (date: { month: string, year: string }) => { valid: number, failedValidationMessage?: string };
        forceHighlightErrors?: boolean;
    };

    years: Number[];

    dateChanged(date: { month: string, year: string }): void;
}

interface State {
    month: string;
    year: string;

    validationMessage: string | null;
}

export default class MonthAndYearPicker extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            month: this.props.value.month,
            year: this.props.value.year,

            validationMessage: null,
        };
    }

    renderMonthOptions() {
        const today = new Date();

        return months.map(m => {

            if (this.state.year && this.state.year === today.getFullYear().toString()) {
                if (Number(this.state.month) > today.getMonth() + 1) {
                    return (
                        <option key={m} value={m} disabled={true}>
                            {this.props.showMonthName ? monthName[Number(m) - 1] : m}
                        </option>
                    );
                }
            }

            return (
                <option key={m} value={m}>
                    {this.props.showMonthName ? monthName[Number(m) - 1] : m}
                </option>
            );
        });
    }

    renderYearOptions = () => {
        return this.props.years.map(year => {
            const twoDigitYear = +year - 2000;

            return (
                <option key={twoDigitYear} value={twoDigitYear}>
                    {year}
                </option>
            );
        });
    }

    renderErrorLabel = (isValid: number, message: string | undefined) => {
        return (
            <label
                style={
                    isValid !== 0 && isValid !== 1 ? 
                    {
                    lineHeight: '11em',
                    color: '#F44336',
                } : 
                {
                    display: 'none'
            }}
            >
                {message}
            </label>
        );
    }

    render() {
        const value = this.props.value ? this.props.value : { month: '', year: '' };
        
        let valid: boolean = true;

        const validationResult = this.props.validation.validator({ month: this.state.month, year: this.state.year });

        if (this.props.validation.forceHighlightErrors) {
            valid = validationResult.valid === 0;
        }
        
        const { divClassName, labelClassName, monthSelectClassName, yearSelectClassName, selectClassName } = this.props.displayOptions || {
            divClassName: '',
            labelClassName: '',
            monthSelectClassName: '',
            yearSelectClassName: '',
            selectClassName: '',
        };

        return (
            <>
                <div
                    id={`${this.props.id}-input-field`}
                    className={`input-field split-select ${divClassName}`}
                >
                    <Select
                        selectClassName={selectClassName}
                        value={value.month}
                        onChange={(month: string) => {
                            this.setState({ month: month });
                            this.props.dateChanged({
                                month: this.state.month,
                                year: this.state.year,
                            });
                        }}
                        css={`validate ${valid || 'invalid'} ${monthSelectClassName}`}
                    >
                        <option value="" disabled={true}>
                            Month
                        </option>

                        {this.renderMonthOptions()}

                    </Select>

                    <label data-error={validationResult.failedValidationMessage}>
                        {this.props.title}
                    </label>

                    <Select
                        selectClassName={selectClassName}
                        value={value.year.toString()}
                        onChange={(year: string) => {
                            this.setState({ year: year });
                            this.props.dateChanged({
                                month: this.state.month,
                                year: this.state.year,
                            });
                        }}
                        css={`validate ${valid || 'invalid'} ${yearSelectClassName}`}
                    >
                        <option value="" disabled={true}>
                            Year
                        </option>

                        {this.renderYearOptions()}

                    </Select>
                    {this.renderErrorLabel(validationResult.valid, validationResult.failedValidationMessage)}
                </div>
            </>
        );
    }

}


// WEBPACK FOOTER //
// ./src/Components/MonthAndYearPicker.tsx